import { render, staticRenderFns } from "./NavBackButton.vue?vue&type=template&id=5314786a&scoped=true&"
import script from "./NavBackButton.vue?vue&type=script&lang=js&"
export * from "./NavBackButton.vue?vue&type=script&lang=js&"
import style0 from "./NavBackButton.vue?vue&type=style&index=0&id=5314786a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314786a",
  null
  
)

export default component.exports